<template>
  <div :class="getContainerClass" :style="resoRatio">
    <CustomStyle />
    <ELYXModalBase v-if="shouldShowModal" />
    <InfoModal v-if="helpCenter && isAuthenticated" />
    <MessengerModal v-if="messengerOpen && isAuthenticated" />
    <ReportModal v-if="reportModal && isAuthenticated" />
    <OnboardingChecks
      v-if="user && user._id && isAuthenticated && $route.meta.calendar && onboardingComplete === false && onboardingLoaded && !activeModal"
    />
    <VideoModal v-if="welcomeVideoOpen && isAuthenticated" />
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CustomStyle from "./CustomStyle";
import messengerSocket from "./socket/messengerSocket";
import { ELYXCentralStore, BadgeStore } from "./ELYX/ELYXStore";

/* import coreAPI from "./api/coreAPI"; */
import auth from "./api/auth";

import { initErrorLogging } from "./utilities/errorLogger";

import ELYXModalBase from "./ELYXComponents/ELYXModalBase.vue";
import CalendarMethods from "./ELYX/Calendar/CalendarMethods";
import InternalUtilities from "./ELYX/Internal/InternalUtilities";

/* import { capture } from "./utilities/logger";
import auth from "./api/auth";

import TimeMe from "../node_modules/timeme.js/timeme"; */

export default {
  name: "App",
  components: {
    CustomStyle,
    ELYXModalBase,
    InfoModal: () => import("./components/Widgets/InfoModal/InfoModal.vue"),
    MessengerModal: () => import("@/components/MessengerModal/MessengerModal"),
    ReportModal: () => import("./components/Reporting/ReportModal.vue"),
    VideoModal: () => import("./components/Onboarding/VideoModal.vue"),
    OnboardingChecks: () => import("./components/Onboarding/OnboardingChecks.vue"),
  },
  created() {
    console.log("Hello. I am Macintosh.");
    console.log("Make the small things unforgettable.");
    /* Initialize logging errors */
    initErrorLogging();
    InternalUtilities.storeTTCLID(); // store ttclid if exists

    /* this.ensureSocketListeners(); */

    /* this.setResoRatios();
    TimeMe.initialize({
      idleTimeoutInSeconds: 90, // seconds
    });
    if (navigator && navigator.userAgent) {
      this.isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i);
    }
    var pageLeaveEvent = this.isOnIOS ? "visibilitychange" : "beforeunload";
    window.addEventListener(pageLeaveEvent, this.sendLog); // helps detect refresh */
  },
  /* beforeRouteUpdate(to, from, next) {
    this.sendLog();
  }, */

  /*   beforeDestroy() {
    this.sendLog();
  }, */
  /*   beforeRouteLeave(to, from, next) {
    this.sendLog(true, next);
  }, */
  data() {
    return {
      heightResoRatio: 1,
      widthResoRatio: 1,
      isOnIOS: false,
      iOSLoggerInterval: 0,
    };
  },
  computed: {
    activeModal: () => ELYXCentralStore.state.activeModal,
    unawardedBadges: () => BadgeStore.state.unawardedBadges,

    shouldShowModal() {
      /** An active modal has been set and either is location-independent OR is in the right location */
      return this.activeModal && (!this.activeModal.location || this.$route.meta[this.activeModal.location]);
    },

    ...mapState({
      ready: (state) => state.auth.ready,
      user: (state) => state.auth.user,
      isAuthenticated: (state) => state.auth.authenticationStatus,
      preferenceSettingsOpen: (state) => state.cofocusPreferences.preferenceSettingsOpen,
      messengerOpen: (state) => state.messages.modalOpened,
      welcomeVideoOpen: (state) => state.onboarding.welcomeVideoOpen,
      notices: (state) => state.notices.notices,
      helpCenter: (state) => state.modals.helpCenter,
      reportModal: (state) => state.modals.reportModal,
      onboardingComplete: (state) => state.onboarding.onboardingComplete,
      onboardingLoaded: (state) => state.onboarding.onboardingLoaded,
    }),

    getPageContainerClass() {
      let containerClass = "page-container";
      if (this.$route.meta.landingPage && this.user && this.$route.path == "/") {
        containerClass = "page-container full";
      }
      return containerClass;
    },
    getContainerClass() {
      let containerClass = "app-container";
      if (this.$route.meta.landingPage && !this.user && this.$route.path == "/") {
        containerClass = "landing-container full flex-column";
      }
      return containerClass;
    },
    getNavState() {
      return !this.$route.meta.hideNavigation;
    },
    resoRatio() {
      return {
        "--heightResoRatio": this.heightResoRatio,
        "--widthResoRatio": this.widthResoRatio,
      };
    },
  },
  methods: {
    async initApp() {
      this.ensureSocketListeners();
      this.initMixpanel();
      CalendarMethods.getNrOfUsedFreeSessions();
    },

    /* Ensure 1) Refreshing 2) Route leave also perform update */
    async sendLog(fromBeforeLeave = false, next = null) {
      await this.createCapture();
      var pageLeaveEvent = this.isOnIOS ? "visibilitychange" : "beforeunload";
      window.removeEventListener(pageLeaveEvent, this.sendLog);
      if (fromBeforeLeave && next !== null) {
        next();
      }
    },
    /* async createCapture() {
      let timeSpentOnPage = TimeMe.getTimeOnCurrentPageInSeconds();
      let UID = "";
      let authenticated = false;
      if (this.user && this.user._id && this.isAuthenticated) {
        UID = this.user._id;
        authenticated = true;
      }
      let pathName = window.location.pathname;
      await capture(authenticated, UID, timeSpentOnPage, pathName);
    }, */
    /* async createIOSCapture() {
      if (document.hasFocus()) {
        await this.createCapture();
      } else {
        setTimeout(this.createIOSCapture, 15000);
      }
      // Not utilized because current backend would track each update
      // as a new page view, as such another flow-logic would be need to
      // be applied to support iOS.
      // setTimeout(this.createIOSCapture, 15000);
    }, */
    ensureSocketListeners() {
      /* ensures that the sockets that must always be on are always on */
      messengerSocket.initMessengerSocket();
    },

    setResoRatios() {
      let designedHeight = 940;
      let designedWidth = 1680;
      let availHeight = window.screen.availHeight;
      let availWidth = window.screen.availWidth;
      let devicePixelRatio = window.devicePixelRatio;
      if (devicePixelRatio === 2) return;
      /* availWidth = availWidth * devicePixelRatio;
      availHeight = availHeight * devicePixelRatio; */
      if (availWidth > availHeight) {
        this.heightResoRatio = designedHeight / availHeight;
        this.widthResoRatio = designedWidth / availWidth;
      }
    },

    initMixpanel() {
      const traits = {};
      if (this.user.displayName) traits.$name = this.user.displayName;
      if (this.user.email) traits.$email = this.user.email;
      if (Intl.DateTimeFormat().resolvedOptions().timeZone) traits.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      /* Check whether localhost */
      if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof console !== "undefined") {
        traits.localhost = true;
      }
      if (navigator && navigator.userAgent) {
        traits.userTech = navigator && navigator.userAgent;
      }
      window.mixpanel.identify(this.user._id);
      window.mixpanel.people.set(traits);
    },
  },
  watch: {
    isAuthenticated: async function (newStatus) {
      if (newStatus) {
        this.initApp();
      }
    },
    ready: async function () {
      let UID = "";
      if (this.user && this.user._id && this.isAuthenticated) {
        UID = this.user._id;
      }
      if (UID == "61f22e550347910016d32e91") {
        await auth.logout();
        window.location.reload();
      }
    },
    $route: async function () {
      let UID = "";
      if (this.user && this.user._id && this.isAuthenticated) {
        UID = this.user._id;
      }
      if (UID == "61f22e550347910016d32e91") {
        await auth.logout();
        window.location.reload();
      }

      ELYXCentralStore.methods.checkIfAnyModalsNeedOpening();
    },
    /* ready: async function() {
      if (this.isOnIOS) {
        // Because iOS does not support any page leave events, then we at least capture the page view itself with some data
        await this.createIOSCapture();
      }
    }, */
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@380;400;500;600;700;800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Square+Peg&display=swap");

@font-face {
  font-family: "F37 Ginger Regular";
  src: url("../public/fonts/F37-Ginger-Regular.ttf") format("truetype");
  font-weight: 200 800;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "F37Ginger";
  src: url("../public/fonts/F37Ginger.ttf") format("truetype");
  font-weight: 200 700 800;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Variable";
  src: url("../public/fonts/GeneralSans-Variable.woff2") format("woff2"), url("../public/fonts/GeneralSans-Variable.woff") format("woff"),
    url("../public/fonts/GeneralSans-Variable.ttf") format("truetype");
  font-weight: 200 700;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Extralight";
  src: url("../public/fonts/GeneralSans-Extralight.woff2") format("woff2"), url("../public/fonts/GeneralSans-Extralight.woff") format("woff"),
    url("../public/fonts/GeneralSans-Extralight.ttf") format("truetype");
  font-weight: 200;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Light";
  src: url("../public/fonts/GeneralSans-Light.woff2") format("woff2"), url("../public/fonts/GeneralSans-Light.woff") format("woff"),
    url("../public/fonts/GeneralSans-Light.ttf") format("truetype");
  font-weight: 300;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Regular";
  src: url("../public/fonts/GeneralSans-Regular.woff2") format("woff2"), url("../public/fonts/GeneralSans-Regular.woff") format("woff"),
    url("../public/fonts/GeneralSans-Regular.ttf") format("truetype");
  font-weight: 400;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Medium";
  src: url("../public/fonts/GeneralSans-Medium.woff2") format("woff2"), url("../public/fonts/GeneralSans-Medium.woff") format("woff"),
    url("../public/fonts/GeneralSans-Medium.ttf") format("truetype");
  font-weight: 500;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Semibold";
  src: url("../public/fonts/GeneralSans-Semibold.woff2") format("woff2"), url("../public/fonts/GeneralSans-Semibold.woff") format("woff"),
    url("../public/fonts/GeneralSans-Semibold.ttf") format("truetype");
  font-weight: 600;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "GeneralSans-Bold";
  src: url("../public/fonts/GeneralSans-Bold.woff2") format("woff2"), url("../public/fonts/GeneralSans-Bold.woff") format("woff"),
    url("../public/fonts/GeneralSans-Bold.ttf") format("truetype");
  font-weight: 700;
  font-display: swap;
  font-style: normal;
}

@font-face {
  font-family: "PPNeueMontreal";
  src: url("../public/fonts/PPNeueMontreal-Bold.otf") format("opentype");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "PPNeueMontreal";
  src: url("../public/fonts/PPNeueMontreal-Book.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "PPNeueMontreal";
  src: url("../public/fonts/PPNeueMontreal-Italic.otf") format("opentype");
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: "PPNeueMontreal";
  src: url("../public/fonts/PPNeueMontreal-Medium.otf") format("opentype");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "PPNeueMontreal";
  src: url("../public/fonts/PPNeueMontreal-SemiBolditalic.otf") format("opentype");
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: "PPNeueMontreal";
  src: url("../public/fonts/PPNeueMontreal-Thin.otf") format("opentype");
  font-weight: 100;
  font-style: normal;
}

.messageTextLink {
  color: #5a5a5a;
  text-decoration: underline;
}

.messageTextLink:hover {
  color: blue;
}

#app {
  font-family: "Nunito", "Helvetica", "Arial", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

html,
body {
  height: 100%;
  overflow: hidden;
  font-family: "Nunito", "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", Arial, sans-serif;
}

body {
  overscroll-behavior-y: none;
  overscroll-behavior-x: none;
}

a {
  text-decoration: none;
  color: #111;
}
a:visited {
  color: #333;
}

.app-container {
  height: 100%;
  width: 100%;
  overflow: scroll;
}

.full {
  height: 100%;
}

.borderless {
  border: none;
}

button {
  font-family: "Nunito", "Helvetica", "Arial", sans-serif;
  outline: none;
  border: none;
  cursor: pointer;
  background-color: transparent;
}

input,
input[type="text"] {
  font-family: "Nunito", "Helvetica", "Arial", sans-serif;
  outline: none;
  border: none;
}

/* Button styles */

.button {
  outline: none;
  background-color: #493eff;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: unset;
  padding: 10px;
  width: 100%;
  border-radius: 3px;
  cursor: pointer;
  display: block;
  margin: 0 auto;
  margin-top: 25px;
  max-width: 275px;
}
.button:hover {
  background-color: #493effd1;
}

.mb-20 {
  margin-bottom: 20px !important;
}

.flex {
  display: flex;
}

.text-align-center {
  text-align: center;
}

.dont-break-out {
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;

  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;

  /* Adds a hyphen where the word breaks, if supported (No Blink) */
}

.land {
  overflow-y: scroll;
}
svg {
  display: inline-block;
  vertical-align: baseline;
}
</style>
